import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { datadogRum } from '@datadog/browser-rum';
export const DatadogViewTracker = () => {
    const location = useLocation();
    const { i18n } = useTranslation();
    const locale = i18n.language;
    // Keep locale in global RUM context so all future events carry it,
    // but don't start a new view when only the locale changes.
    useEffect(() => {
        if (!locale)
            return;
        datadogRum.setGlobalContextProperty('locale', locale);
    }, [locale]);
    // Manually start a new RUM view only when the route/path changes.
    useEffect(() => {
        const routePath = location.pathname || '/';
        datadogRum.startView(routePath);
    }, [location.pathname]);
    return null;
};
